// import vnBsTopay from './index.vue'
// vnBsTopay.install = function(Vue){
//   Vue.component(vnBsTopay.name, vnBsTopay)
// }
// export default vnBsTopay
import vnBsToApp from "./index.vue";
import Vue from 'vue'
let root = null;
function createComponent(component, props) {
    const conCtor = Vue.extend(component)
    const el = new conCtor({propsData: props}).$mount()
    document.body.appendChild(el.$el)
    el.remove = function () {
        document.body.removeChild(el.$el);
        el.$destroy();
        root = null;
    };
    return el
}

export default { 
    vnToApp( props = {} ) {
        if(root){
            root.remove()
        }
        root = createComponent(vnBsToApp, props)
        return root;
    }
}
